/**
 * Token appended by the native Android shell WebView (MainActivity).
 * Lets us fall back to a custom-scheme navigation when addJavascriptInterface is flaky.
 */
export const REMORI_ANDROID_UA_TOKEN = 'RemoriAndroid';

/** Opens native reminder/settings UI when embedded in the Remori iOS or Android shell. */
export function openNativeSettings(event) {
  const ios = window.webkit?.messageHandlers?.remoriOpenSettings;
  if (ios) {
    event?.preventDefault?.();
    ios.postMessage({});
    return true;
  }

  const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
  const looksLikeRemoriAndroid =
    ua.includes(REMORI_ANDROID_UA_TOKEN) ||
    (typeof window.RemoriAndroid !== 'undefined' && window.RemoriAndroid !== null);

  if (!looksLikeRemoriAndroid) {
    return false;
  }

  event?.preventDefault?.();

  const bridge = window.RemoriAndroid;
  try {
    if (bridge != null && typeof bridge.openSettings === 'function') {
      bridge.openSettings();
      return true;
    }
  } catch (_) {
    /* Fall through — WebView sometimes hides interfaces until navigations settle */
  }

  /* Reliable fallback: intercepted by Android WebViewClient (defer avoids WebView re-entrancy crashes). */
  setTimeout(() => {
    window.location.assign('remori://app/settings');
  }, 0);
  return true;
}
